<div class="row ">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">


                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-6">
                        <div class="form-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   (keyup)="buscarTodo($event)" />
                        </div>
                    </div>

                    <div class="col-6">
                        <form>

                            <div class="row float-right">

                                <div class="col-sm-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">

                                            <a type="button"
                                               [routerLink]="'/panel/almacen/new'"
                                               class="btn btn-outline-info btn-circle"
                                               title="Nuevo">
                                                <i class="fa-solid fa-plus"></i>
                                            </a>
                                            <button type="button"
                                                    (click)="cargaLista()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                </div>




                <div class="rounded border">
                    <!-- datatable -->
                    <ngx-datatable class="bootstrap"
                                   [rows]="rows"
                                   [limit]="rowsLimit"
                                   [loadingIndicator]="loading"
                                   [columnMode]="ColumnMode.force"
                                   [headerHeight]="50"
                                   [footerHeight]="50"
                                   [summaryRow]="false"
                                   [summaryHeight]="55"
                                   [summaryPosition]="'bottom'"
                                   [rowHeight]="'auto'"
                                   [messages]="messages"
                                   [reorderable]="true">



                        <!-- codigo -->
                        <ngx-datatable-column name="Cód"
                                              prop='codigo'
                                              [width]="70"
                                              [maxWidth]="70"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- nombre -->
                        <ngx-datatable-column name="Nombre"
                                              prop='nombre'
                                              [width]="150"
                                              [maxWidth]="200">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- ubiPlaya -->
                        <ngx-datatable-column name="Playa"
                                              prop='ubiPlaya'
                                              [width]="170"
                                              [maxWidth]="170"
                                              [resizeable]="false">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <!-- <div style="font-family: 'Verdana', monospace; letter-spacing: 0.2px;"
                                     title="{{funcLib.CodUbiDecript(value)}}"
                                     [innerHTML]="funcLib.resaltarTexto(value | mask: '00.00.00.00.00.00', textoDestacado | mask: '00.00.00.00.00.00')"></div> -->

                                <div title={{funcLib.CodUbiDecript(value)}}
                                     class="monospace"
                                     [innerHTML]="funcLib.resaltarTexto(funcLib.formatUbicacion(value), textoDestacado | mask: '00.00.00.00.00.00')"></div>


                            </ng-template>
                        </ngx-datatable-column>


                        <!-- descripcion -->
                        <ngx-datatable-column name="Descripción"
                                              prop='descripcion'
                                              [width]="300"
                                              [maxWidth]="500">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- direccion / cp / poblacion / provincia -->
                        <ngx-datatable-column name="Dirección"
                                              [width]="500"
                                              [maxWidth]="600">
                            <ng-template let-row="row"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(row.direccion+' ('+row.cp+ ' '+row.poblacion+')' , textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- Acciones -->
                        <ngx-datatable-column [width]="50"
                                              [maxWidth]="100"
                                              [sortable]="false"
                                              [resizeable]="false">


                        </ngx-datatable-column>






                        <!-- Acciones -->
                        <ngx-datatable-column [flexGrow]="10"
                                              [sortable]="false"
                                              [draggable]="false"
                                              [resizeable]="false">

                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left">

                                        <a [routerLink]="['/panel/almacen',row.id]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Editar Almacén">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar Almacén
                                        </a>

                                        <hr style="margin: 0px;">

                                        <!-- <a (click)="row.swOcupado !== '1' ? deleteRow(row) : null"
                                           class="link mr-2 dropdown-item text-danger"
                                           title="Borrar"
                                           [class.disabled]="row.swOcupado === '1'"
                                           [attr.aria-disabled]="row.swOcupado === '1' ? true : null">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar
                                        </a> -->

                                        <a (click)="  null"
                                           class="link mr-2 dropdown-item text-danger"
                                           title="Borrar"
                                           [class.disabled]="true"
                                           [attr.aria-disabled]="true">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar
                                        </a>


                                    </div>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>



                    </ngx-datatable>
                </div>

            </div>
        </div>
    </div>

</div>